<template>
  <div id="addAccount">
    <h3>添加账号</h3>
    <div class="import_box">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
      <div class="steps-content">
        <div v-if="current === 0" class="import_flex step_contnet0">
          <div class="accinfoView">
            <div class="a">
              <div class="info">
                <div class="cow">
                  <span>绿萝账号:</span>
                  <a-input placeholder="请输入" v-model="lvluoAccount" @blur="accoutHandle"/>
                  <span class="warning" v-show="isShow">账号不符合要求</span>
                  <p>账号仅支持最少6位的英文数字组合</p>
                </div>
                <div class="cow">
                  <span>密码:</span>
                  <a-input placeholder="请输入" v-model="password" @blur="passHandle"/>
                  <span class="warning" v-show="isShow1">密码不符合要求</span>
                  <p>密码请输入6位以上的英文数字组合</p>
                </div>
                <div class="cow">
                  <span>姓名:</span>
                  <a-input placeholder="请输入" v-model="full_name"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="current === 1" class="step_contnet1">
          <div class="select">
            <span>设置账号权限：</span>
            <a-select placeholder="请选择" style="width: 250px" @change="handleChange" allowClear>
              <!-- <a-select-option value="超级管理员">超级管理员</a-select-option> -->
              <a-select-option value="1">管理员</a-select-option>
            </a-select>
          </div>
          <div v-if="role_id == 1">
            <div class="division">
              <div class="explain">
                <div>
                  <span>权限说明：</span>
                </div>
                <div style="width: 400px">
                  <span>拥有管理员权限的通常是学校领导层，管理员可以看到全校的各类数据以及工作情况，但不能做分发测评等操作。随意给出管理员账号可能会造成学校私密数据泄露的情况，请慎重创建。
                  </span>
                </div>
                
              </div>

            </div>
            <div class="qrCode">
              <div style="padding-right:17px">
                <img src="@/assets/qrCode.png" alt="">
              </div>
              <div>
                <p>管理员账号登录流程</p>
                <p>关注微信公众号【智慧心育】点击菜单栏【平台入口】-【学校入口】</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="current === 2" class="import_flex step_contnet">
					<div>
            <div class="success">
                <img src="@/assets/complete_icon.png" alt="">
								<p>操作成功</p>
            </div>
						<div class="gray">
							<div class="accountInfo">
									<div class="a">
										<div class="info">
											<div class="successcow">
												<span>绿萝账号:</span>
												<span>{{lvluoAccount}}</span>
											</div>
											<div class="successcow">
												<span>密码:</span>
												<span>{{password}}</span>
											</div>
											<div class="successcow">
												<span>姓名:</span>
												<span>{{full_name}}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
        </div>
      </div>
      <div class="steps-action">
        <a-button v-if="current === 0" type="primary" :disabled="isNext" @click="next">下一步</a-button>
        <a-button v-if="current === 1" @click="prev" style="margin-right: 12px">上一步</a-button>
        <a-button v-if="current === 1" type="primary" :disabled="isCommit" @click="submitHandle">提交</a-button>
        <a-button v-if="current === 2" @click="back">返回</a-button>
      </div>
    </div>
    <div class="edit_grade">
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'AddUserAccount',
  data () {
    return {
      current: 0,
      steps: [
        {
          title: '填写基本信息'
        },
        {
          title: '设置权限范围'
        },
        {
          title: '完成'
        }
      ],
      lvluoAccount: null,
      password: null,
      full_name: null,
      currentTwoText: [],
      role_id: null,
      isShow: false,
      isShow1: false
    }
  },
  computed: {
    ...mapState([
      'teacherAdmin',
      'schoolGrades',
      'isAddAccount'
    ]),
    isNext () {
      if (this.isShow === false && this.isShow1 === false && (this.full_name !== null && this.full_name !== "")) {
        return false
      }else{
        return true
      }
    },
    isCommit () {
      if (this.role_id == 1) {
        return false
      } else {
        return true
      }
    }
  },
  async mounted () {
    
  },
  methods: {
    ...mapActions([
      'addAccount'
      
    ]),
    ...mapMutations([
    ]),
    next () {
      this.accoutHandle()
      this.passHandle()
      this.current++
      console.log(this.current)
    },
    prev () {
      this.current--
      console.log(this.current)
      this.role_id = null
		},
		back () {
      this.$router.push('/userList/accountset')
    },
    handleChange(value) {
        console.log({value});
        this.role_id = value
      },
    async submitHandle () {
      let result = {
        uid : this.teacherAdmin.uid,
        school_id  :this.teacherAdmin.school_id,
        user_name : this.lvluoAccount,
        password: this.password,
        real_name: this.full_name,
        role_id: "2"
      }
      await this.addAccount(result)
      if (this.isAddAccount === true) {
        this.$message.success('提交成功')
        this.current++
      } else{
        this.$message.error('用户名重复')
      }
    },
    accoutHandle () {
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
      if (reg.test(this.lvluoAccount)){
        this.isShow = false
      } else{
        this.isShow = true
      }
    },
    passHandle () {
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
      if (reg.test(this.password)){
        this.isShow1 = false
      } else{
        this.isShow1 = true
      }
    }
  }
}
</script>

<style>
#addAccount {
  width: 100%;
  box-sizing: border-box;
}
#addAccount .import_flex {
  display: flex;
  align-items: center;
}
#addAccount h3 {
  font-size: 24px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 24px;
}
#addAccount .import_box {
  width: 100%;
  padding: 40px;
  background-color: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-sizing: border-box;
}
#addAccount .steps-content {
  box-sizing: border-box;
}
#addAccount .ant-btn-link, #addAccount .ant-btn-link:focus {
  color: #262626; 
}
#addAccount .ant-btn-link:hover, #addAccount .down_con a:hover {
  color: #1890FF;
}
#addAccount .step_contnet0 {
  /* justify-content: center; */
  margin-bottom: 40px;
}
#addAccount .step_contnet1 {
  /* justify-content: center; */
  margin-bottom: 40px;
}
#addAccount .step_contnet1 .select{
  margin-top: 40px;
}
#addAccount .step_contnet1 .division{
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(217,217,217,1)
}
#addAccount .step_contnet1 .division .explain{
  display: flex;
  margin-top: 24px;
}
#addAccount .step_contnet1 .qrCode{
  display: flex;
  margin-top: 30px;
}
#addAccount .step_contnet {
  justify-content: center;
  margin-bottom: 40px;
}
#addAccount .step_contnet .success{
	text-align: center;
  padding-top: 48px;    
}
#addAccount .step_contnet .success>p{
	padding-top: 24px;
	font-size:16px;
	font-weight:500;
	color:rgba(38,38,38,1);
	line-height:16px;  
}
#addAccount .step_contnet .gray{
	width: 500px;
	height:122px;
	background:rgba(245,245,245,1);
}
#addAccount .steps-action {
  text-align: center;
}
#addAccount .ant-steps-item-process .ant-steps-item-icon, #addAccount .ant-btn-primary {
  background-color: #51BF94;
  border-color: #51BF94;
  color: #FFFFFF;
}
#addAccount .ant-btn-primary:hover {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .6);
  border-color: rgba(81, 191, 148, .6);
}
#addAccount .ant-steps-item-finish .ant-steps-item-icon {
  border-color: #51BF94;
}
#addAccount .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #51BF94;
}
.accinfoView{
  padding-left: 308px;
}
.infoView .a{
  margin: auto;
}
.info{
  margin-top: 40px;
}
.info div{
  margin-bottom: 20px;
}
.info .successcow{
	padding-top: 16px;
	margin-bottom: 0px;
}
.info .successcow>span:first-child{
  display: inline-block;
  width:249px;
  text-align: right;
  margin-right: 12px;
}
.info .cow>span:first-child{
  display: inline-block;
  width:90px;
  text-align: right;
  margin-right: 12px;
}
.info .cow p{
  margin-left: 114px;
  margin-top: 16px;
  font-size:14px;
  font-weight:400;
  color:rgba(140,140,140,1);
  line-height:14px;
}
.info .cow .warning{
  font-size:14px;
  font-weight:400;
  color:rgba(245,34,45,1);
  line-height:14px;
  padding-left: 10px;
}
.info .username{
  display: inline-block;
  width: 250px;
  text-align: left;
}
.info a{
  display: inline-block;
  width: 250px;
  text-align: left;
}
.info .ant-input-affix-wrapper{
  width: auto;
}
.info .ant-input{
  width: 250px;
  height: 38px;
}
</style>
